import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/Button/Button';
import useOnSubmit from './hooks/useOnSubmit';

import ChangeAssessmentStateModal from '../ChangeAssessmentStateModal/ChangeAssessmentStateModal';

const RevertToOpen = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const onSubmit = useOnSubmit(setIsOpen);

  return (
    <>
      <Button className="revert-to-open" variant="tertiary" onClick={() => setIsOpen(true)}>
        {t('pages.projectOverview.mainPanel.revertToOpen.button')}
      </Button>
      <ChangeAssessmentStateModal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        onSubmit={onSubmit}
        title={t('pages.projectOverview.mainPanel.revertToOpen.modalTitle')}
        submitButton={
          <Button className="revert-to-open" variant="tertiary" type="submit">
            {t('pages.projectOverview.mainPanel.revertToOpen.button')}
          </Button>
        }
      />
    </>
  );
};

export default RevertToOpen;
